import React, {useState} from "react"
import {Button, FormLabel, Modal} from "react-bootstrap"
import {putConversation} from "../../lib/api";
import {EditableText} from "../Shared/EditableWidgets";
import {Conversation} from "./Conversations";

function EditConversationConfig(props: {
  conversation: Conversation,
  setConversation: any,
  show: boolean;
  onHide: () => void;
}) {
  const {conversation, setConversation, show, onHide} = props;
  const [error, setError] = useState(null);
  const [enabled, setEnabled] = useState(true);
  const [userResponseWaitTime, setUserResponseWaitTime] = useState(conversation.config.userResponseWaitTime);
  const [userResponseWaitTimeAfterFirstWord, setUserResponseWaitTimeAfterFirstWord] = useState(conversation.config.userResponseWaitTimeAfterFirstWord);
  const [aiTaskWaitTime, setAiTaskWaitTime] = useState(conversation.config.aiTaskWaitTime);

  function showModal() {
    setUserResponseWaitTime(parseFloat(conversation.config.userResponseWaitTime.toString()) || 0);
    setUserResponseWaitTimeAfterFirstWord(parseFloat(conversation.config.userResponseWaitTimeAfterFirstWord.toString()) || 0);
    setAiTaskWaitTime(parseFloat(conversation.config.aiTaskWaitTime.toString()) || 0);
    setError(null);
  }

  function save() {
    setError(null);
    setEnabled(false);
    putConversation({
      ...conversation, ...{
        config: {
          userResponseWaitTime,
          userResponseWaitTimeAfterFirstWord,
          aiTaskWaitTime
        }
      }
    }).then(saveResponseHandler);
  }

  function saveResponseHandler(response: any) {
    if (response.ok) {
      setConversation({
        ...conversation, ...{
          config: {
            userResponseWaitTime,
            userResponseWaitTimeAfterFirstWord,
            aiTaskWaitTime
          }
        }
      });
      onHide()
    } else {
      // @ts-ignore
      response.json().then(json => {
        setError(json?.error);
      });
    }
    setEnabled(true);
  }

  function toFloat(value: string, setter: any) {
    // try to allow only digits and a decimal point
    // however currently if someone types a letter it sets it to empty string (not sure why) which results in 0.1 in the last line here
    const digits = value.replace(/[^0-9.]/g, '');
    setter(parseFloat(digits) || 0.1);
  }

  if (!conversation) return null;

  return (
    <Modal show={show}
           className="conversation-config-modal"
           animation={false}
           onShow={showModal}
           onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Conversation Config</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-12">
            <FormLabel className="mb-1 h-auto">User response wait time</FormLabel>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <EditableText
              value={userResponseWaitTime}
              type="number"
              step={0.1}
              onChange={(event: any) => toFloat(event.target.value, setUserResponseWaitTime)}
              isEditable={true}
              isEditing={true}
              setIsEditing={() => {
              }}
              placeholder="User response wait time"
              ariaLabel="User response wait time”"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <FormLabel className="my-1 h-auto">User pause at end of speaking</FormLabel>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <EditableText
              value={userResponseWaitTimeAfterFirstWord}
              type="number"
              step={0.1}
              onChange={(event: any) => toFloat(event.target.value, setUserResponseWaitTimeAfterFirstWord)}
              isEditable={true}
              isEditing={true}
              setIsEditing={() => {
              }}
              placeholder="User pause at end of speaking"
              ariaLabel="User pause at end of speaking"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <FormLabel className="my-1 h-auto">AI wait before skipping to next task</FormLabel>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <EditableText
              value={aiTaskWaitTime}
              type="number"
              step={0.1}
              onChange={(event: any) => toFloat(event.target.value, setAiTaskWaitTime)}
              isEditable={true}
              isEditing={true}
              setIsEditing={() => {
              }}
              placeholder="User pause at end of speaking"
              ariaLabel="User pause at end of speaking"
            />
          </div>
        </div>
        {error ?
          (
            <div className="row error">
              <div className="col-12">
                {(error as any)?.message}
              </div>
            </div>
          )
          : null
        }
      </Modal.Body>
      <Modal.Footer>
        <div className="row px-0">
          <Button
            variant="secondary"
            className="ml-2"
            onClick={onHide}
            disabled={!enabled}
          >
            Cancel
          </Button>
          <Button
            onClick={save}
            style={{marginLeft: "10px"}}
            variant="primary"
            disabled={!enabled}
          >
            Save
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

export default EditConversationConfig;
